import store from 'store';
import client from './graphQlClient';
import {
    GET_GAIN_ACCOUNTS_BY_IDS,
    GET_GAIN_ACCOUNT_GROUPS_BY_IDS,
    GET_CUSTOM_ACCOUNTS_BY_IDS,
    SEARCH_THIRD_PARTY_COMPANIES,
    CREATE_CUSTOM_COMPANY,
    SEARCH_THIRD_PARTY_COMPANY_PARENTS,
} from './queries/ThirdPartyCompanyQueries';
import { getDivision } from '_legacy/reducers/userSelectors';

// Aborting the HTTP request (not just ignoring the response) lets the server stop superseded searches
const cancellableQuery = (options, cancelToken) =>
    new Promise((resolve, reject) => {
        const abortController = new AbortController();

        client()
            .query({
                ...options,
                context: { fetchOptions: { signal: abortController.signal } },
            })
            .then(resolve, reject);

        cancelToken.promise.then((reason) => {
            abortController.abort();
            reject(reason);
        });
    });

export default class ThirdPartyCompanyApi {
    static search = (search, companyWeightingType, groupId, cancelToken) => {
        const division = getDivision(store.getState());
        return cancellableQuery(
            {
                query: SEARCH_THIRD_PARTY_COMPANIES,
                fetchPolicy: 'no-cache',
                variables: {
                    search,
                    division,
                    groupId,
                    companyWeightingType,
                },
            },
            cancelToken
        ).then((result) => result.data.thirdPartyCompanies);
    };

    static searchParents = (search, cancelToken) => {
        const division = getDivision(store.getState());
        return cancellableQuery(
            {
                query: SEARCH_THIRD_PARTY_COMPANY_PARENTS,
                fetchPolicy: 'no-cache',
                variables: {
                    search,
                    division,
                },
            },
            cancelToken
        ).then((result) => result.data.thirdPartyCompanyParents);
    };

    static getAccountsByIds = (ids) => {
        const division = getDivision(store.getState());
        return client()
            .query({
                query: GET_GAIN_ACCOUNTS_BY_IDS,
                fetchPolicy: 'no-cache',
                variables: {
                    ids,
                    division,
                },
            })
            .then((result) => result.data.gainAccountsByIds);
    };

    static getAccountGroupsByIds = (ids) => {
        const division = getDivision(store.getState());
        return client()
            .query({
                query: GET_GAIN_ACCOUNT_GROUPS_BY_IDS,
                fetchPolicy: 'no-cache',
                variables: {
                    ids,
                    division,
                },
            })
            .then((result) => result.data.gainAccountGroupsByIds);
    };

    static getCustomAccountsByIds = (ids) => {
        const division = getDivision(store.getState());
        return client()
            .query({
                query: GET_CUSTOM_ACCOUNTS_BY_IDS,
                fetchPolicy: 'no-cache',
                variables: {
                    ids,
                    division,
                },
            })
            .then((result) => result.data.customAccountsByIds);
    };

    static createCustomCompany = (createCustomCompanyModel) =>
        client()
            .query({
                query: CREATE_CUSTOM_COMPANY,
                fetchPolicy: 'no-cache',
                variables: {
                    createCustomCompanyModel,
                },
            })
            .then((result) => result.data.createCustomCompany);
}
